import { SessionStorageService } from 'src/services/session-storage/session-storage.service';

function getZendeskStatus() {
  const iframeLauncher: HTMLIFrameElement = document.querySelector("iframe#launcher");
  if (!iframeLauncher || !iframeLauncher.contentDocument || !iframeLauncher.contentDocument.body) {
    return "unloaded";
  }
  const iframeWidget: HTMLIFrameElement = document.querySelector("iframe#webWidget");
  if (!iframeWidget || !iframeWidget.contentDocument || !iframeWidget.contentDocument.body) {
    return "unloaded";
  }
  const ticketSubmissionForm:HTMLElement = iframeWidget.contentDocument.body.querySelector("#Embed > div > *");
  if (!ticketSubmissionForm) {
    return "closed";
  }
  const inputs = ticketSubmissionForm.querySelectorAll("input");
  if (inputs.length < 2) {
    return "unknown";
  }
  if (inputs[0].value || inputs[1].value) {
    return "written"
  }
  return "empty";
}

function autofillZendesk(root: HTMLElement, sessionStorage: SessionStorageService) {
  const isDebug = window.location.hostname === "localhost";
  if (isDebug) console.log("Auto fill started");
  const name = sessionStorage.getItem('name');
  const email = sessionStorage.getItem('email');

  if (!name || !email) {
    if (isDebug) console.log("Name or Email are not present");
    return;
  }

  if (getZendeskStatus() !== "empty") {
    if (isDebug) console.log("Zendesk status is not 'empty'");
    return;
  }

  try {
    const iframeWidget: HTMLIFrameElement = root.querySelector("iframe#webWidget");
    const ticketSubmissionForm = iframeWidget.contentDocument.body.querySelector("#Embed > div > *");
    const labels = ticketSubmissionForm.querySelectorAll("label")
    labels.forEach(label => label.style.pointerEvents = "none");
    const inputs = ticketSubmissionForm.querySelectorAll("input");
    if (inputs.length < 2) {
      return;
    }
    inputs[0].value = name;
    inputs[1].value = email;
    if (isDebug) console.log(`Set name as "${name}" and email as "${email}"`);
    if (inputs[2]) {
      inputs[2].focus();
    }
  } catch (err) {
    if (isDebug) console.log(err);
  }
}

export async function applyZendeskClickHook(sessionStorage: SessionStorageService) {
  let button: HTMLButtonElement;
  let isFirstTime = true;
  while (true) {
    await new Promise(resolve => setTimeout(resolve, isFirstTime ? 400 : 1000));
    isFirstTime = false;
    const iframeLauncher: HTMLIFrameElement = document.querySelector("iframe#launcher");
    if (!iframeLauncher || !iframeLauncher.contentDocument || !iframeLauncher.contentDocument.body) {
      continue;
    }
    button = iframeLauncher.contentDocument.body.querySelector("button");
    if (!button) {
      continue;
    }
    break;
  }

  if (button.hasAttribute("data-has-reportsfeed-listener")) {
    console.warn("Button already had listener");
    return;
  }
  button.setAttribute("data-has-reportsfeed-listener", "1");
  const outside = document.body;
  button.addEventListener("click", setTimeout.bind(this, autofillZendesk.bind(this, outside, sessionStorage), 500));
  button.addEventListener("click", setTimeout.bind(this, autofillZendesk.bind(this, outside, sessionStorage), 2000));
}

export default autofillZendesk;
